import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';

/** The same saved theme preference across all employee workspaces. */
const ThemeToggle: React.FC = () => {
  const { resolved, toggle } = useTheme();
  const { i18n } = useTranslation();
  const isDark = resolved === 'dark';
  const isGreek = i18n.language.startsWith('el');
  const label = isGreek
    ? (isDark ? 'Ανοιχτό θέμα' : 'Σκούρο θέμα')
    : (isDark ? 'Light theme' : 'Dark theme');

  return (
    <button type="button" onClick={toggle} aria-label={label} title={label}
      className="shrink-0 w-11 h-11 rounded-xl bg-surface-2 border border-line text-t3 hover:bg-surface-3 hover:text-t1 flex items-center justify-center transition-colors">
      {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
    </button>
  );
};

export default ThemeToggle;
